import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { migrateLocalStorage, hasMigrated, markMigrated } from '../utils/migrateLocalStorage';

function hasLocalData() {
  const keys = ['lpo_sailors','lpo_priorities','lpo_reminders','lpo_passdown','lpo_programs','lpo_notes','lpo_evals','lpo_awards','lpo_selres','lpo_crossassigned'];
  return keys.some(k => { try { return JSON.parse(localStorage.getItem(k))?.length > 0; } catch { return false; } });
}

export default function MigrationBanner() {
  const { user }   = useAuth();
  const [visible, setVisible] = useState(() => !hasMigrated() && hasLocalData());
  const [running, setRunning] = useState(false);
  const [done, setDone]       = useState(false);
  const [count, setCount]     = useState(0);

  if (!visible) return null;

  const handleMigrate = async () => {
    setRunning(true);
    const { migrated } = await migrateLocalStorage(user.uid);
    markMigrated();
    setCount(migrated);
    setDone(true);
    setRunning(false);
  };

  const handleDismiss = () => {
    markMigrated();
    setVisible(false);
  };

  const style = {
    background: 'rgba(201,168,76,0.12)',
    border: '1px solid rgba(201,168,76,0.4)',
    borderRadius: '8px',
    padding: '12px 16px',
    margin: '12px 16px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    flexWrap: 'wrap',
  };

  if (done) return (
    <div style={{ ...style, background: 'rgba(46,204,113,0.1)', border: '1px solid rgba(46,204,113,0.3)' }}>
      <span style={{ fontSize: '0.85rem', color: 'var(--success)' }}>
        Imported {count} item{count !== 1 ? 's' : ''} to your cloud account. Your data is safe.
      </span>
      <button onClick={() => setVisible(false)} style={{ background: 'none', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer', fontSize: '0.8rem' }}>Dismiss</button>
    </div>
  );

  return (
    <div style={style}>
      <span style={{ fontSize: '0.85rem', color: 'var(--text)' }}>
        We found existing data on this device. Import it to your cloud account so it is never lost?
      </span>
      <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
        <button
          onClick={handleMigrate}
          disabled={running}
          style={{ background: 'var(--gold)', color: '#000', border: 'none', borderRadius: '6px', padding: '6px 14px', fontWeight: 700, fontSize: '0.8rem', cursor: running ? 'not-allowed' : 'pointer' }}>
          {running ? 'Importing...' : 'Import'}
        </button>
        <button
          onClick={handleDismiss}
          style={{ background: 'none', border: '1px solid var(--border)', borderRadius: '6px', padding: '6px 14px', color: 'var(--text-secondary)', fontSize: '0.8rem', cursor: 'pointer' }}>
          No thanks
        </button>
      </div>
    </div>
  );
}
